import * as React from "react";
const StopFilled = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,7 L16,7 C16.5522847,7 17,7.44771525 17,8 L17,16 C17,16.5522847 16.5522847,17 16,17 L8,17 C7.44771525,17 7,16.5522847 7,16 L7,8 C7,7.44771525 7.44771525,7 8,7 Z" }));
StopFilled.displayName = "StopFilled";
var StopFilled_default = StopFilled;
export {
  StopFilled_default as default
};
